import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import CardDetailView from '../views/CardDetailView.vue'
import ProductDetailView from '../views/ProductDetailView.vue'
import ExchangeView from '../views/ExchangeView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { title: '礼品券兑换' },
  },
  {
    path: '/card-detail', // 卡片详情页路由
    name: 'CardDetail',
    component: CardDetailView,
  },
  {
    path: '/product-detail',
    name: 'ProductDetail',
    component: ProductDetailView,
  },
  {
    path: '/exchange',
    name: 'Exchange',
    component: ExchangeView,
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
